import React from 'react';
import { Link } from 'react-router-dom';
const avatar = "https://res.cloudinary.com/startup-grind/image/upload/c_fill,w_250,h_250,g_center/c_fill,dpr_2.0,f_auto,g_center,q_auto:good/v1/gcs/platform-data-goog/avatars/chang_yunghan_3C30lCH.jpg"

const Founder = () => {
    return (
        <>
            <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id='about' >

                <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="fade-up">

                    <div className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8" data-aos="zoom-in" data-aos-delay="500">

                        <h3 className="text-3xl  text-amber-500 font-bold">
                            創辦人經歷
                        </h3>
                        <div>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>
                                Google developer group co-organizer
                            </p>
                        </div>

                        <div>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>
                                2024 Build with AI speaker
                            </p>
                        </div>

                        <div>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>
                                2024 臺灣生成式AI應用黑客松競賽 智慧城市 銀獎
                            </p>
                        </div>

                        <div>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>
                                2022 Google devfest speaker
                            </p>
                        </div>

                        <div>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>
                                2021 Google developer group speaker
                            </p>
                        </div>

                    </div>
                    <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                        <img alt="card img" className="rounded-full float-right" src={avatar} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Founder;